import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';

const STEPS = [
  {
    title: 'DEKOSTA nedir?',
    body: 'Fiziksel kartların üstündeki aktivasyon kodu ile dijital koleksiyonunu büyütürsün. Her kart benzersiz, sahibi sensin.',
    emoji: '🎴',
  },
  {
    title: 'Aktivasyon nasıl?',
    body: 'Kartı eline al, uygulamada Aktive ekranına gel. Kodu kamerayla okutabilir veya elden yazabilirsin.',
    emoji: '📷',
  },
  {
    title: 'Koleksiyonunu büyüt',
    body: 'Albümlerin dolar, başarımlar açılır, görevlerle XP kazanırsın. 7 günlük seriyle özel profil arka planları açılır.',
    emoji: '🏆',
  },
  {
    title: 'Arkadaş ekle, takas yap',
    body: 'Kullanıcı adı ile arkadaş ekle, profilinden takas öner. Takımlare katıl, ortak koleksiyon skorunu yarış.',
    emoji: '🤝',
  },
];

const ONBOARDING_DONE_KEY = 'dekosta_onboarding_done';

const OnboardingTutorial = () => {
  const { user, completeOnboarding } = useAuth();
  const [step, setStep] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  // Backend'de onboarding_completed alanı/endpoint'i henüz yok; tamamlama localStorage'da
  // tutulur ki modal kapansın ve tekrar açılmasın (backend POST yine best-effort denenir).
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(ONBOARDING_DONE_KEY) === '1';
    } catch (_) {
      return false;
    }
  });

  // Yalnızca onboarding_completed = false olan loglu kullanıcılar için
  if (!user) return null;
  if (user.onboarding_completed === true || dismissed) return null;

  const finish = async () => {
    setSubmitting(true);
    try {
      await completeOnboarding();
    } catch (_) {
      // Backend endpoint yoksa/başarısızsa bile kullanıcıyı tutma — localStorage ile kapat
    } finally {
      try {
        localStorage.setItem(ONBOARDING_DONE_KEY, '1');
      } catch (_) {
        /* */
      }
      setSubmitting(false);
      setDismissed(true);
    }
  };

  const isLast = step >= STEPS.length - 1;
  const current = STEPS[step];

  return (
    <div className="fixed inset-0 z-[125] bg-black/90 backdrop-blur-sm flex items-center justify-center px-4">
      <div className="w-full max-w-sm glass-effect rounded-2xl p-7 border border-white/10 shadow-xl">
        <div className="text-center mb-4">
          <div className="text-5xl mb-3">{current.emoji}</div>
          <h2 className="text-lg font-bold text-white" style={{ fontFamily: 'Cinzel, serif' }}>
            {current.title}
          </h2>
        </div>
        <p className="text-sm text-zinc-300 leading-relaxed text-center mb-5">
          {current.body}
        </p>

        <div className="flex justify-center gap-1.5 mb-5">
          {STEPS.map((_, i) => (
            <div
              key={i}
              className={`w-2 h-2 rounded-full transition-colors ${
                i === step ? 'bg-violet-400' : i < step ? 'bg-violet-700' : 'bg-white/15'
              }`}
            />
          ))}
        </div>

        <div className="flex gap-2">
          {step > 0 && (
            <Button
              variant="outline"
              onClick={() => setStep((s) => s - 1)}
              disabled={submitting}
              className="flex-1"
            >
              Geri
            </Button>
          )}
          {!isLast ? (
            <Button
              onClick={() => setStep((s) => s + 1)}
              className="flex-1 btn-primary"
              data-testid="onboarding-next"
            >
              İleri
            </Button>
          ) : (
            <Button
              onClick={finish}
              disabled={submitting}
              className="flex-1 btn-primary"
              data-testid="onboarding-finish"
            >
              {submitting ? 'Bitiriliyor...' : 'Hadi başlayalım'}
            </Button>
          )}
        </div>

        <button
          type="button"
          onClick={finish}
          disabled={submitting}
          className="text-[11px] text-zinc-500 hover:text-zinc-300 mx-auto block mt-3"
        >
          Geç
        </button>
      </div>
    </div>
  );
};

export default OnboardingTutorial;
